import { useFunction } from "@aec-craft/nb-generative";
import { XIcon } from "lucide-react";
import { memo, useEffect, useRef } from "react";
import { useSnackbarStore } from "./snackbar.store";

const duration = 6;

export const SnackbarItem = memo<{ id: string; message: string }>(
	({ id, message }) => {
		const { removeMessage } = useSnackbarStore.getState();
		const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

		const onClose = useFunction(() => {
			removeMessage(id);
		});

		useEffect(() => {
			timerRef.current = setTimeout(onClose, duration * 1000);
			return () => clearTimeout(timerRef.current);
		}, [onClose]);

		return (
			<div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 animate-in fade-in slide-in-from-bottom-4">
				<div className="relative flex items-center gap-2 rounded-lg border border-destructive/50 bg-destructive/10 px-4 py-2 text-sm text-destructive shadow-lg">
					{message}
					<button
						type="button"
						onClick={onClose}
						className="ml-2 rounded-sm opacity-70 hover:opacity-100"
					>
						<XIcon className="size-4" />
					</button>
					<div className="absolute bottom-0 left-0 right-0 h-0.5 bg-destructive/50 origin-left animate-[shrink_6s_linear_forwards]" />
				</div>
			</div>
		);
	},
);
SnackbarItem.displayName = "SnackbarItem";
